import { Typography } from '@mui/material'

// Types
import type { TitleProps } from '@/types/components/atoms/shape/title'

// Helpers
import { useTitle } from '@/helpers/context/title'

// Utils
import Camelize from '@/utils/camelize'

// Metadata
const TitleAtom = (props: TitleProps) => {
	// Props
	const { appName } = props

	// Variables
	const { title } = useTitle()

	return (
		<Typography component="h1" sx={{ fontSize: { xs: 18, md: 24 }, fontWeight: 600 }}>
			{Camelize(title.replace(` | ${appName}`, ''))}
		</Typography>
	)
}

export default TitleAtom
